import { useQuery, useLazyQuery } from "@apollo/client/react";import moment from "moment";
import { usePersistFilters } from "../../../hooks/usePersistFilters";
import { useState, useEffect } from "react";

import { GET_DELEGACIONES_BY_USUARIO } from "../../../data/graphQL/queries/PacienteProbable/getAllDelegacionesByUsuario";
import { adaptDelegacionReclamosArray } from "../../../adapters/delegacionAdapter";
import { GET_USUARIO_DELEGACION_ORIGEN } from "../../../data/graphQL/queries/usuarios/getUsuarioDelegacionOrigen";
import { mesesEnum, periodosEnum } from "../constants";
import { GET_PACIENTES_VISITA, adaptPacientes } from "../../../data/graphQL/queries/MisVisitas/getPacientesVisita";
import { useDebounce } from "../../../hooks/useDebounce";
import toast from "react-hot-toast";
const userId = sessionStorage.getItem('idUsuario');

export const useGetFilters = () => {
  const [delegaciones, setDelegaciones] = useState([]);
  const [pacientes, setPacientes] = useState([]);
  const [pacientesOriginal, setPacientesOriginal] = useState([]);

  const { filters, handleChangeFilters } = usePersistFilters({
    estado: 'En curso',
    textInput: '',
    textInputPaciente: '',
    tipoVisita: 1,
    idPaciente: '',
    idDelegacion: null,
    mes: mesesEnum.find((m) => m.value === parseInt(moment().format('MM'))).code,
    anio: parseInt(moment().format('YYYY')),
    periodo: periodosEnum.at()
  }, `MisVisitasFilters`);

  const debouncedTextFilter = useDebounce(filters.textInputPaciente, 1000);

  const { data: delegacionesData } = useQuery(GET_DELEGACIONES_BY_USUARIO, {
    fetchPolicy: 'no-cache',
    variables: { idUsuario: JSON.parse(userId, 10) }
  });

  useEffect(() => {
		if (!delegacionesData) return;
    setDelegaciones(adaptDelegacionReclamosArray(delegacionesData));
	}, [delegacionesData]);

  const { data: delegacionOrigenData } = useQuery(GET_USUARIO_DELEGACION_ORIGEN, {
    fetchPolicy: 'no-cache',
    variables: { idUsuario: JSON.parse(userId, 10) }
  });

  useEffect(() => {
		if (!delegacionOrigenData) return;
    if (delegacionOrigenData.usuarioFull.success) {
      const deleg = parseInt(delegacionOrigenData.usuarioFull.valorEsperado.delegacionOrigen, 10);
      sessionStorage.setItem('delegacionOrigen', deleg);
      if (filters.idDelegacion == null)
        handleChangeFilters('idDelegacion', deleg);
    }
	}, [delegacionOrigenData]);

  const [getPacientesVisitas, { data: pacientesData, loading: pacienteLoading }] = useLazyQuery(GET_PACIENTES_VISITA, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
		if (!pacientesData) return;
    if (pacientesData?.pacientesVisita)
      setPacientesOriginal(adaptPacientes(pacientesData));
	}, [pacientesData]);

  useEffect(() => {
    if (!pacienteLoading) {
      if (isNaN(filters?.idDelegacion) && filters?.idDelegacion !== null)
      toast.error('Por favor, seleccione una delegación válida.');else

      getPacientesVisitas({variables: { idDelegacion: filters.idDelegacion }});
    }
  }, [filters.tipoVisita, filters.idDelegacion]);

  return {
    filters,
    handleChangeFilters,
    delegaciones,
    pacientes: pacientesOriginal
  };
};